// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__N9w6B","label":"Section_label__OIzWE","contentWrap":"Section_contentWrap__1I7y6","footer":"Section_footer__28ads","footerInner":"Section_footerInner__3FkLu"};